module.exports = __webpack_public_path__ + "img/accessability_cn.b5f92cb.jpg";